export const EFT_BASE_PATH = "/efteruddannelse";

export const eftPath = (segment = ""): string =>
  segment ? `${EFT_BASE_PATH}/${segment.replace(/^\//, "")}` : EFT_BASE_PATH;

export const eftHashPath = (hash: string): string =>
  `${EFT_BASE_PATH}#${hash.replace(/^#/, "")}`;
